<template>
    <v-data-table
    :headers="headers"
    :items="seatData"
    hide-actions
    hide-headers
    class="seat-info-table mb-3"
    >
        <template v-slot:headers="props">
            <th  v-for="header in props.headers" :key="header.text" :class="[`text-xs-${header.align}`,'pa-0']">
                {{header.text}}
            </th>
        </template>
        <template v-slot:items="props">
            <tr class="text-xs-center pointer-events-none">
                <td class="border-grey-all d-inline-flex  pa-1">
                    <div v-for="seatStatus, index in props.item.seatStatus" :key="index" class="d-inline-flex justify-center align-center mx-2">
                        <SeatSVG :width="'3vmin'" :classifier="seatStatus.colorClass"></SeatSVG>
                        <span class="px-1">{{seatStatus.label}}</span>
                    </div>
                </td>
                <v-divider vertical></v-divider>
                <td class="border-grey-all d-inline-flex pa-1">
                    <div v-for="category, index in props.item.categories" :key="index" class="d-inline-flex justify-center align-center mx-2">
                        <SeatSVG :width="'3vmin'" :classifier="category.colorClass"></SeatSVG>
                        <span class="px-1">{{$t(category.label)}}</span>
                    </div>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
import SeatSVG from "@/components/SeatSVG"

export default {
    name:"SeatsClassifier",
    data(){
        return{
            headers: [
                {
                    text: this.$t('screener.physical.event.seats.status.title'),
                    align: 'center',
                    sortable: false,
                    value: 'status'
                },
                {
                    text: this.$t('screener.physical.event.seats.categories.title'),
                    align: 'center',
                    sortable: false,
                    value: 'category'
                },
            ],
            seatData:[
                {
                    seatStatus:[
                        {
                            label: this.$t("screener.seats.status.booked.title"),
                            colorClass:'cls-seat-booked',
                        },
                        {
                            label: this.$t("screener.seats.status.locked.title"),
                            colorClass:'cls-seat-reserved',
                        },
                        {
                            label: this.$t("screener.seats.status.selected.title"),
                            colorClass:'cls-seat-selected',
                        }
                    ],
                    categories:this.DEFINES.SEATS_CATEGORIES,
                }
            ],
        }
    },
    components:{
        SeatSVG
    }
}
</script>

<style scoped>
.seat-info-table{
    width: 100%;
    margin: auto;
}
.pointer-events-none{
    pointer-events: none
}
</style>
